import { combineReducers } from "redux";
import visitors from "./visitor";
import trainees from "./trainee";
import letters from "./letter";
import superAdmin from "./superAdmin";
import channelPartner from "./channelPartner";
import courseCategory from "./courseCategory";
import admin from "./admin";
import skills from "./skills";
import instructor from "./instructor";
import preRequisitesDocument from "./preRequisitesDocument";
import trainingCenters from "./trainingCenter";
import tags from "./tags";
import questionBanks from "./questionBank";
import batch from "./batch";
import course from "./course";
import lesson from "./lesson";
import certificate from "./certificate";
import receipt from "./receipt";
import attendanceModule from "./attendanceModule";
import payment from "./payment";
import assessment from "./assessment";
import documentsApproval from "./documentsApproval";
import issuance from "./issuance";
import signature from "./signature";
import report from "./report";

export const reducers = combineReducers({
  visitors,
  trainees,
  letters,
  superAdmin,
  courseCategory,
  admin,
  skills,
  instructor,
  preRequisitesDocument,
  channelPartner,
  trainingCenters,
  tags,
  questionBanks,
  course,
  lesson,
  certificate,
  batch,
  receipt,
  attendanceModule,
  payment,
  assessment,
  documentsApproval,
  issuance,
  signature,
  report
});
